import { Box, styled } from '@mui/material';
import React from 'react';

const Grid = ({ children, responsive = true, ...rest }) => (
  <StyledGrid responsive={responsive ? 1 : 0} {...rest}>
    {children}
  </StyledGrid>
);

export default Grid;

const StyledGrid = styled(Box)(({ theme, gap, columns = 2, responsive }) => {
  const styles = {
    display: 'grid',
    gridTemplateColumns:
      typeof columns === 'object' ? columns.join(' ') : `repeat(${columns}, 1fr)`,
    gap: gap || theme.spacing(5),
  };

  if (responsive) {
    styles[theme.breakpoints.down('md')] = {
      gridTemplateColumns: 'none',
      // justifyContent: 'center',
    };
  }

  return styles;
});
